<div class="flex flex-col items-center w-full pt-16">
    <div class="text-center p-8">
        <h1 class="text-3xl font-bold text-red-600 mb-4">
            {{ 'ACCESS_DENIED.TITLE' | translate }}
        </h1>
        <p class="text-lg">
            {{ 'ACCESS_DENIED.MESSAGE' | translate }}
        </p>
    </div>
</div>